var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first"},[(!_vm.projectId)?_c('div',[_vm._v("首页内容")]):_vm._e(),_c('overview')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }